export default {
  'moduleTitle.address': 'पता',
  'moduleTitle.address_details': 'पता',
  'moduleTitle.activity_details': 'गतिविधि का विवरण',
  'moduleTitle.add_log': 'लाग अंकित करें',
  'moduleTitle.award_level': 'अवार्ड स्तर',
  'moduleTitle.adventurous_journey': 'साहसिक यात्रा',
  'moduleTitle.already_assessed': 'पहले से ही मूल्यांकन किया गया!',
  'moduleTitle.approved': 'अनुमोदित',
  'moduleTitle.assessor_details': 'मूल्यांकनकर्ता का विवरण',
  'moduleTitle.authorising_contact_license_holder': 'संपर्क / लाइसेंसधारक प्राधिकृत करना',
  'moduleTitle.category_journey_details': '{category} यात्रा विवरण',
  'moduleTitle.complete_report': 'पूरा रिपोर्ट',
  'moduleTitle.completed_progress': 'पूर्ण (finished) / {total}',
  'moduleTitle.congratulation': 'बधाई!',
  'moduleTitle.confirming_email_address': 'ईमेल पते की पुष्टि ...',
  'moduleTitle.contact_details': 'संपर्क विवरण',
  'moduleTitle.edit_log': 'लॉग संपादित करें',
  'moduleTitle.event_journey': '{event} यात्रा ',
  'moduleTitle.forgotten_password': 'पासवर्ड भूल गए',
  'moduleTitle.great_you_are_almost_there': 'बहुत अच्छा, आप अंतिम चरण मैं हैं.  अंतिम चरण, नए पुरस्कार स्तर के लिए भुगतान है',
  'moduleTitle.home_address': 'निवास का पता',
  'moduleTitle.journey_overview': 'यात्रा का अवलोकन',
  'moduleTitle.log_detail': 'लॉग विवरण',
  'moduleTitle.login': 'लॉग इन करें',
  'moduleTitle.new_activity': 'नयी गतिविधि',
  'moduleTitle.new_event_journey': 'नयी {event} यात्रा ',
  'moduleTitle.new_residential_project': 'नया रेजिडेंशियल प्रोजेक्ट',
  'moduleTitle.notRegistred': 'पंजीकृत नहीं?',
  'moduleTitle.nominated_award_leader_contact_details': 'पुरस्कार समन्वयक संपर्क विवरण',
  'moduleTitle.nominated_award_leader': 'पुरस्कार समन्वयक',
  'moduleTitle.organisation_address': 'संगठन का पता',
  'moduleTitle.organisation_details': 'संगठन का पता',
  'moduleTitle.online_record_book_account': 'ऑनलाइन रिकॉर्ड बुक अकाउंट',
  'moduleTitle.page_not_found': '404 पृष्ठ नहीं मिला',
  'moduleTitle.personal_details': 'व्यक्तिगत विवरण',
  'moduleTitle.preparation_and_training': 'तैयारी और प्रशिक्षण',
  'moduleTitle.profile_guardian_consent': 'माता-पिता / अभिभावक सहमति',
  'moduleTitle.profile_questions': 'प्रोफ़ाइल प्रश्न',
  'moduleTitle.registration_for_level': 'अगले स्तर के लिए पंजीकरण',
  'moduleTitle.residential_project': 'रेजिडेंशियल प्रोज़ेक्ट',
  'moduleTitle.residential_project_details': 'रेजिडेंशियल प्रोजेक्ट का विवरण',
  'moduleTitle.reset_password': 'पासवर्ड रीसेट',
  'moduleTitle.welcome_to_the_orb': 'ऑनलाइन रिकॉर्ड बुक में आपका स्वागत है',
  'moduleTitle.we_have_sent_you_an_email': 'हमने आपको एक एक्टिवेशन लिंक के साथ एक ईमेल भेजा है।',
  'moduleTitle.your_registration_is_complete': 'आपका पंजीकरण पूरा हो गया है',
  'formTitle.activity_details': 'गतिविधि का विवरण',
  'formTitle.assessor_details': 'आंकलनकर्ता का विवरण ',
  'formTitle.supervisors_details': 'पर्यवेक्षक का विवरण',
  'formTitle.preparation_and_training_activities': 'तैयारी और प्रशिक्षण क्रियाएँ',
  'formTitle.added_preparation_activities': 'तैयारी और प्रशिक्षण गतिविधियां जोड़ी गयी',
  'label.add_picture': 'चित्र लगायें',
  'label.address_first_line': 'पता प्रथम पंक्ति',
  'label.address_second_line': 'पता दूसरी पंक्ति (वैकल्पिक)',
  'label.are_you_already_running_award': 'क्या आप पहले ही अवार्ड प्रोग्राम चला रहे हैं?',
  'label.are_you_the_main_award_leader': 'क्या आप अपने अवार्ड यूनिट के लिए मुख्य अवार्ड लीडर या समन्वयक हैं?',
  'label.award_participant': 'अवार्ड प्रतिभागी',
  'label.award_leader': 'अवार्ड लीडर',
  'label.birthdate': 'जन्म तिथि',
  'label.category': 'श्रेणी',
  'label.change_locale': 'स्थान बदलें',
  'label.choose_project': 'गतिविधि चुनें',
  'label.city': 'शहर',
  'label.choose_as_major_activity': 'प्रमुख गतिविधि के रूप में चुनें',
  'label.date': 'दिनाकं',
  'label.date_of_birth': 'जन्म की तारीख',
  'label.description_of_progress': 'आपकी प्रगति का विवरण',
  'label.duration': 'अवधि (मिनट)',
  'label.email': 'ईमेल',
  'label.email_address': 'ईमेल पाता',
  'label.email_again': 'ईमेल की पुष्टि करें',
  'label.employment_status': 'रोज़गार की स्थिति',
  'label.end_date': 'अंतिम तिथि',
  'label.enter_his_email': 'ईमेल पता दर्ज करें',
  'label.entered_transaction_id': 'आपका लेनदेन आईडी',
  'label.first_name': 'पहला नाम',
  'label.gender': 'लिंग',
  'label.goal': 'लक्ष्य',
  'label.journey_activity': 'यात्रा गतिविधि',
  'label.journey_objective': 'यात्रा का लक्ष्य',
  'label.journey_observations': 'यात्रा टिप्पणियां',
  'label.journey_type': 'यात्रा का प्रकार',
  'label.last_name': 'अंतिम नाम',
  'label.level': 'स्तर',
  'label.location': 'स्थान',
  'label.logout': 'लोग आउट',
  'label.major': 'प्रमुख',
  'label.middle_name': 'मध्य नाम',
  'label.mode_of_transport': 'परिवहन के साधन',
  'label.my_award_leader': 'मेरा अवार्ड लीडर',
  'label.name': 'नाम',
  'label.nationality': 'राष्ट्रीयता',
  'label.no': 'नम्बर',
  'label.no_results': 'कोई परिणाम नहीं',
  'label.note': 'नोट',
  'label.note_for_assessor': 'मूल्यांकनकर्ता के लिए नोट',
  'label.note_for_leader': 'लीडर के लिए नोट',
  'label.optional': 'वैकल्पिक',
  'label.organisation_name': 'संगठन का नाम',
  'label.organisation_type': 'संगठन का प्रकार',
  'label.others': 'अन्य',
  'label.password': 'पासवर्ड',
  'label.password_again': 'पासवर्ड पुनः डालें',
  'label.project_location': 'प्रोजेक्ट का स्थान',
  'label.pay_online': 'ऑनलाइन भुगतान करें',
  'label.pay_award_leader_or_unit': 'अवार्ड लीडर को या यूनिट को भुगतान करें',
  'label.payment_not_required': 'प्रतिभे के लिए भुगतान आवश्यक नहीं है',
  'label.payment_type': 'भुगतान का प्रकार',
  'label.phone': 'फ़ोन',
  'label.phone_number': 'फ़ोन नंबर',
  'label.phone_type': 'फ़ोन का प्रकार',
  'label.profile': 'प्रोफाइल',
  'label.reset_password': 'पासवर्ड बदलें',
  'label.region': 'राज्य / प्रांत / क्षेत्र',
  'label.relationship': 'संबंध',
  'label.role_in_organisation': 'संगठन में भूमिका',
  'label.select_country': 'देश चुनिए',
  'label.select_your_au': 'अपने अवार्ड यूनिट का चयन करें',
  'label.start_typing': 'टाइप करना शुरू करें',
  'label.start_date': 'आरंभ करने की तिथि',
  'label.select': 'चयन करें',
  'label.select_async': 'टाइप करना शुरू करें ...',
  'label.select_your_operating_authority': 'अपने अवार्ड ऑपरेटिंग अथॉरिटी का चयन करें ',
  'label.specify_category': 'कृपया अपनी श्रेणी निर्दिष्ट करें',
  'label.subcategory': 'उपश्रेणी',
  'label.title': 'शीर्षक',
  'label.username': 'उपयोगकर्ता नाम',
  'label.what_is_your_role': 'आपके संगठन में आपकी भूमिका क्या है?',
  'label.where_have_you_completed': 'आपने कहाँ पूरा किया?',
  'label.yes': 'हाँ',
  'label.your_changes_havent_been_saved': 'आपके परिवर्तन सहेजे नहीं गए हैं डाटा नष्ट हो जाएंगे।',
  'label.zip': 'ज़िप पोस्ट कोड',
  'label.adventurous_journey': 'साहसिक यात्रा',
  'label.after_your_journey_describe': 'कुछ वाक्यों में अपने साहसिक यात्रा की टिप्पणियों का वर्णन करें।',
  'label.because_your_age_is_under_18': 'क्योंकि आप 18 वर्ष से कम उम्र के हैं, हमें आपके माता-पिता / अभिभावक से सहमति की आवश्यकता है।',
  'label.before_you_head_to_journey': 'इससे पहले कि आप अपनी क्वालीफाइंग यात्रा जारी करें, आपको पहले तैयारी और प्रशिक्षण पूरा करना होगा।',
  'label.before_entering_new_level': 'अगले स्तर पर प्रवेश करने से पहले कृपया पुष्टि करें कि आपके व्यक्तिगत विवरण सही हैं।',
  'label.bring_required_amount_to_your_award_leader': 'अपने यूनिट में अपने अवार्ड लीडर या अवार्ड कोऑर्डिनेटर को आवश्यक राशि दें।',
  'label.do_you_have_any_other_level': 'क्या आपने अवार्ड के किसी भी पिछले स्तर को पूरा किया है?',
  'label.do_you_know_who_is_your_award_leader': 'क्या आपको पता है कि आपका अवार्ड लीडर कौन है?',
  'label.going_on_an_expedition': 'एक एक्सपीडिशन पर जाने से आपको एक साहसिक कार्य के अनुभव के साथ एक टीम के रूप में अपनी खुद की पहल पर कार्य काम करने का मौका मिलता है,',
  'label.going_on_residential_gives_chance': 'एक आवासीय क्षेत्र में जाने से आपको यह जानने का मौका मिलता है कि अलग-अलग पृष्ठभूमि वाले लोगों के साथ कैसे काम करें और नए वातावरण में आत्मविश्वास का निर्माण करें।',
  'label.i_confirm_that_i_meet': 'मैं पुष्टि करता हूं कि मैं  NAO की सभी विनियमन आवश्यकताएं पूरी करता हूं।',
  'label.i_agree_to_volunteer_code': 'मैं स्वयंसेवी आचार संहिता के लिए सहमत हूं। अधिक जानकारी के लिए यहां क्लिक करें।',
  'label.i_have_read_the_terms_and_conditions': 'मैंने नियम और शर्तों को पढ़ा है और उनके साथ सहमत हूं।',
  'label.i_will_bring_the_consent_to_my_award_leader_later': 'मैं अपनी अवार्ड की अनुमति बाद में मेरे अवार्ड लीडर को दूंगा / दूँगी',
  'label.if_you_are_from_orphanage': 'उदाहरण के लिए, यदि आपका स्कूल या युवा संगठन आपकी ओर से भुगतान करता है',
  'label.here_you_can_add_activity': 'यहां आप एक अतिरिक्त तैयारी और प्रशिक्षण गतिविधि जोड़ सकते हैं',
  'label.how_do_you_want_to_apply': 'आप कैसे आवेदन करना चाहते हैं:',
  'label.my_parent_consent_has_been_already_given': 'मेरे अभिभावक / अभिभावक द्वारा सहमति पहले ही मेरे अवार्ड लीडर को दे दी गई है।',
  'label.my_parent_will_confirm_consent_by_email': 'मेरे माता-पिता / अभिभावक ईमेल द्वारा सहमति की पुष्टि करेंगे',
  'label.major_activity_means_that_you_have_to_spent': 'प्रमुख गतिविधि का मतलब है कि आपको इस गतिविधि पर अन्य लोगों की तुलना में दोगुना ज्यादा समय व्यतीत करना पड़ता है ।',
  'label.not_sure_about_your_auth': 'अगर आप अनिश्चित हैं कि आपको कौन सा अवार्ड अथॉरिटी के साथ रजिस्टर होना चाहिए, तो कृपया अपने क्षेत्रीय कार्यालय से संपर्क करें।',
  'label.page_not_found': '404 पृष्ठ नहीं मिला।',
  'label.please_fill_in_the_following': 'कृपया अपने संगठन में प्राधिकृत संपर्क / लाइसेंस धारक के लिए निम्नलिखित विवरण भरें',
  'label.register_a_new_account_as': 'एक नया खाता इस रूप में पंजीकृत करें:',
  'label.residential_project': 'रेजिडेंशियल प्रोजेक्ट',
  'label.select_your_award_unit': 'अपनी अवार्ड यूनिट चुनें',
  'label.the_expedition_can_be_faraway': 'अभियान बहुत दूर हो सकता है या घर के करीब हो सकता है, और आप इसमें सैकड़ों तरीकों से जा सकते हैं।',
  'label.to_log_your_process_on_orb': 'कृपया अपने ऑनलाइन रिकॉर्ड बुक अकाउंट के निर्माण को पूरा करने के लिए नीचे एक पासवर्ड सेट करें।',
  'label.waiting_for_assessment': 'मूल्यांकन की प्रतीक्षा में',
  'label.waiting_for_sign_off': 'अवार्ड लीडर के साइन-ऑफ की प्रतीक्षा में',
  'label.we_have_sent_you_an_email': 'हमने आपको एक एक्टिवेशन लिंक के साथ एक ईमेल भेजा है।',
  'label.what_level_of_the_award': 'अवार्ड के लिए आप किस स्तर का पंजीकरण कर रहे हैं?',
  'label.you_are_now_registering_as_participant': 'अब आप एक अवार्ड प्रतिभागी के रूप में पंजीकरण कर रहे हैं',
  'label.you_are_now_registering_as_award_unit': 'अब आप एक अवार्ड यूनिट के रूप में पंजीकरण कर रहे हैं।',
  'label.you_can_use_my_photos_for_promotional_purposes': 'एक अवार्ड प्रतिभागी के रूप में, मैं प्रचार उद्देश्यों के लिए अपनी तस्वीरों / चित्रों का उपयोग करने के लिए फाउंडेशन को मेरी सहमति देता हूं।',
  'label.you_can_send_activity_for_approval': 'आप अनुमोदन के लिए अब अपनी गतिविधि मूल्यांकनकर्ता को भेज सकते हैं।',
  'label.you_can_send_activity_for_leader': 'अब आप अनुमोदन के लिए अपने अवार्ड लीडर को अपनी गतिविधि भेज सकते हैं।',
  'label.you_can_send_residential_project_to_leader': 'अब आप अपने रेजिडेंशियल प्रोजेक्ट को अपने अवार्ड लीडर को अनुमोदन के लिए भेज सकते हैं।',
  'label.you_have_finished_now_send_to_approval': 'आपकी गतिविधि समाप्त हो गई है अब आप इसे अपने निर्धारक के लिए अनुमोदन के लिए जमा कर सकते हैं। आप नीचे एक निजी नोट भी जोड़ सकते हैं',
  'label.preparation_and_training': 'तैयारी और प्रशिक्षण',
  'label.you_will_be_redirected_to_the_payment': 'अपना वीज़ा, मास्टर कार्ड क्रेडिट कार्ड या वीज़ा डेबिट कार्ड का उपयोग करके ऑनलाइन भुगतान करने के लिए नीचे दिए गए पे बटन पर क्लिक करें।',
  'label.you_will_be_the_first_award_leader': 'आप अपने संगठन में प्रथम अवार्ड लीडर होंगे। आपको ऑनलाइन रिकॉर्ड बुक सिस्टम के माध्यम से और अधिक पुरस्कार नेता, प्रतिभागियों को जोड़ने और पुरस्कार की प्रक्रिया का प्रबंधन करने का अधिकार होगा।',
  'label.youll_receive_a_notification': 'जब आपके अवार्ड लीडर आपके पंजीकरण को मंजूरी दे देंगे, तो आपको एक सूचना प्राप्त होगी। आप ऑनलाइन रिकॉर्ड बुक <a> यहां </a> पर लॉग ऑन कर सकते हैं (जब तक आपके अवार्ड लीडर \nआपके पंजीकरण को मंजूरी नहीं देते है केवल तब तक आपकी कार्यक्षमता सीमित  होगी)।',
  'label.your_parent_email': 'आपके माता-पिता / अभिभावक ईमेल',
  'label.your_parent_first_name': 'आपके माता-पिता / संरक्षक प्रथम नाम',
  'label.your_parent_last_name': 'आपके माता-पिता / संरक्षक अंतिम नाम',
  'label.your_report_approve_now_send_to_leader': 'आपकी रिपोर्ट मंजूर कर दी गई है! अब आप इसे अपने अवार्ड लीडर को अनुमोदन के लिए जमा कर सकते हैं। आप नीचे एक निजी नोट भी जोड़ सकते हैं',
  'label.there_are_loads_of_exciting_possibilities': 'यहाँ बहुत सारे रोमांचक संभावनाएं और अवसर है, कुछ ऐसी चीज़ चुनें, जिसे आप पूरा कर सकते हैं।',
  'label.your_residential_project_has_been_setup': 'आपका रेजिडेंशियल प्रोजेक्ट सेटअप किया गया है और अनुमोदन के लिए आपके अवार्ड लीडर को भेजा गया है।',
  'label.your_report_has_been_sent_assessor': 'आपकी रिपोर्ट अनुमोदन के लिए आपके मूल्यांकनकर्ता को भेज दी गई है।',
  'label.your_report_has_been_sent_leader': 'आपकी रिपोर्ट अनुमोदन के लिए आपके अवार्ड लीडर को भेज दी गई है।',
  'label.your_residential_project_is_complete': 'आपका रेजिडेंशियल प्रोजेक्ट पूरा हो गया है।',
  'label.to_work_on_the_online': 'ऑनलाइन रिकॉर्ड बुक (ORB) पर काम करने के लिए आपको निजी ORB खाते की आवश्यकता है',
  'label.we_will_send_you_an_email': 'जब आपका ORB खाता पंजीकरण स्वीकृत हो जाता है तो हम आपको एक ईमेल भेजेंगे।',
  'label.if_you_have_any_problems_or_doubts': 'अगर आपको कोई समस्या है या संदेह है तो कृपया अधिक जानकारी के लिए आपको अवार्ड यूनिट से संपर्क करें।',
  'label.are_you_sure_you_want_to_leave': 'क्या पक्का आप इसे छोड़ना चाहते हैं? डाटा नष्ट हो जाएंगे।',
  'label.no_logs_yet': 'अभी तक कोई लॉग नहीं है। <br /> "लॉग जोड़ें" बटन दबाकर अपना पहला लॉग जोड़ने का प्रयास करें',
  'label.menu': 'मेन्यू',
  'notifications.award_unit_has_been_created': 'अवार्ड यूनिट बना दी गई है',
  'notifications.authorization_code_is_not_valid': 'औथोरिज़ेशन कोड मान्य नहीं है',
  'notifications.email_has_been_confirmed': 'ईमेल पते की पुष्टि की गई है',
  'notifications.leader_has_been_created': 'लीडर बना दिया गया है',
  'notifications.participant_has_been_created': 'प्रतिभागी बना दिया गया है',
  'notifications.email_with_instructions_has_been_sent': 'निर्देशों के साथ ईमेल भेजा गया है',
  'notifications.your_new_password_has_been_set': 'आपका नया पासवर्ड सेट कर दिया गया है',
  'notifications.success': 'सफलता',
  'notifications.unknown_role': 'अज्ञात भूमिका',
  'notifications.waiting_for_approval': 'अनुमोदन के लिए प्रतीक्षा',
  'notifications.activity_cannot_be_created': 'जब तक आपका पंजीकरण स्वीकृत नहीं हो जाता तब तक गतिविधि नहीं बनाई जा सकती',
  'notifications.new_activity_has_been_added': 'नई गतिविधि जोड़ दी गई है',
  'notifications.new_log_has_been_added': 'नया लॉग जोड़ दिया गया है',
  'notifications.log_has_been_deleted': 'लॉग हटा दिया गया है',
  'notifications.log_has_been_modified': 'लॉग को संशोधित किया गया है',
  'notifications.adventurous_journey_cannot_be_created_until_approved': 'जब तक कि आपका पंजीकरण स्वीकृत नहीं हो जाता है तब तक साहसिक यात्रा नहीं बने जा सकती',
  'notifications.new_participant_event_has_been_added': 'नई प्रतिभागी घटना को जोड़ा गया है',
  'notifications.participant_event_has_been_completed': 'प्रतिभागी घटना पूरी हो चुकी है',
  'notifications.training_and_practice_modified': 'प्रशिक्षण और प्रथा को संशोधित किया गया है',
  'notifications.completion_residential_project_completed': 'रेजिडेंशियल प्रोजेक्ट पूरा हो गया है',
  'notifications.new_residential_project_has_been_added': 'नया रेजिडेंशियल प्रोजेक्ट जोड़ दिया गया है',
  'notifications.residential_project_cannot_be_created_until_approved': 'जब तक कि आपका पंजीकरण स्वीकृत नहीं हो जाता है तब तक रेजिडेंशियल प्रोजेक्ट नहीं बनाया जा सक्ता',
  'notifications.already_assessed_sent': 'लीडर अनुमोदन अनुरोध भेजा गया है',
  'notifications.assessment_request_sent': 'आकलन अनुरोध भेजा गया है',
  'notifications.leader_approval_sent': 'लीडर अनुमोदन अनुरोध भेजा गया है ',
  'tabs.logs': 'लॉग्स',
  'tabs.new': 'नया',
  'tabs.overview': 'अवलोकन',
  'tabs.report': 'रिपोर्ट',
  'button.add_activity': 'गतिविधि जोड़ें',
  'button.add_log': 'लॉग जोड़ें',
  'button.continue_here': 'यहां जारी रखें',
  'button.continue': 'जारी रखें',
  'button.continue_to_award': 'अवार्ड जारी रखें',
  'button.delete': 'हटायें',
  'button.edit': 'संपादित करें\n',
  'button.edit_log': 'लॉग संपादित करें',
  'button.finish': 'समाप्त',
  'button.forgot_your_password': 'क्या आप अपना पासवर्ड भूल गए?',
  'button.i_already_have_assessment': 'मेरे पास एक आकलन है',
  'button.leave_anyway': 'छोड़ दें',
  'button.login': 'लॉग इन करें',
  'button.no': 'नहीं',
  'button.register': 'पंजीकृत करें',
  'button.send': 'भेजें',
  'button.send_for_approval': 'अनुमोदन के लिए भेजें',
  'button.setup': 'सेट अप',
  'button.setup_residential': 'रेजिडेंशियल प्रोजेक्ट सेटअप करें',
  'button.stay': 'रहना',
  'button.submit': 'जमा करें',
  'button.update': 'अपडेट',
  'button.yes': 'हाँ',
  'errors.at_least_num_characters': 'कम से कम {length} वर्ण लंबा',
  'errors.do_not_match': 'मेल नहीं खाता',
  'errors.include_at_least_one_number': 'कम से कम एक संख्या शामिल करें',
  'errors.include_both_lower_and_upper_case': 'निम्न और ऊपरी केस दोनों वर्ण शामिल करें',
  'errors.invalid_phone_format': 'अमान्य फ़ोन प्रारूप',
  'errors.invalid_email_address': 'अमान्य ईमेल पता',
  'errors.required_field': 'आवश्यक फ़ील्ड',
  'errors.must_be_at_least': 'कम से कम {min} वर्ण होने चाहिए',
  'errors.must_be_no_more_than': '{max} वर्णों से अधिक नहीं होना चाहिए',
  'errors.must_be_an_integer': 'पूर्णांक होना चाहिए',
  'errors.must_contain_at_least': 'कम से कम एक नंबर शामिल होना चाहिए',
  'errors.must_include_at_least': 'कम से कम एक ऊपरी केस वर्णों को शामिल करना चाहिए',
  'errors.must_be_one_of': 'इनमें से एक होना चाहिए: {enums}',
  'errors.you_must_be_younger_than': 'अवार्ड के लिए पंजीकरण करने के लिए आपको {years} वर्ष और {months} महीने से कम उम्र का होना चाहिए। कृपया इस बारे में अपने अवार्ड यूनिट स्टाफ से बात करें।',
  'errors.you_must_be_older_than': 'अवार्ड के लिए पंजीकरण करने के लिए आपको {years} वर्ष और {months} महीनों से अधिक उम्र का होना चाहिए। कृपया इस बारे में अपने अवार्ड यूनिट स्टाफ से बात करें।',
  'errors.email_address_is_in_use_please_sign': 'ई-मेल पता पहले से प्रयोग में है, यदि आप एक अन्य स्तर के लिए पंजीकृत करना चाहते हैं, तो आपके खाते में साइन इन करें।',
  'errors.email_address_is_in_use': 'ईमेल पता पहले से ही इस्तेमाल में है।',
  'errors.sorry_we_already_have_this_email': "क्षमा करें, हमारे पास पहले से ही इस ईमेल के साथ एक खाता पंजीकृत है। यदि आप अगले स्तर को प्रारंभ करना चाहते हैं, तो <a href='/'> अपने खाते पर लॉग इन करें </a> और अगला स्तर प्रारंभ करें का चयन करें का चयन करें।",
  'wizard.authorising_contact': 'संपर्क को प्राधिकृत किया जा रहा है',
  'wizard.award_leader_contact': 'अवार्ड लीडर संपर्क',
  'wizard.award_unit_details': 'अवार्ड यूनिट का विवरण',
  'wizard.contact_details': 'संपर्क विवरण',
  'wizard.contacts': 'संपर्क',
  'wizard.level': 'अवार्ड स्तर',
  'wizard.level_selection': 'अवार्ड चयन',
  'wizard.leader_details': 'लीडर का विवरण',
  'wizard.nominated_award_leader': 'पुरस्कार समन्वयक',
  'wizard.orb_account': 'ORB खाता',
  'wizard.parent_consent': 'माता-पिता की सहमति',
  'wizard.participant_details': 'प्रतिभागी विवरण',
  'wizard.profile': 'प्रोफाइल',
  'wizard.payment': 'भुगतान',
  'wizard.select_award_unit': 'अवार्ड यूनिट चुनें',
  'wizard.unit_details': 'यूनिट विवरण',
  'wizard.welcome': 'स्वागत है',
  'wizard.your_details': 'आपका विवरण',
  'awardUnit.do_you_want_to_create': 'क्या आप एक नया अवार्ड यूनिट बनाना चाहते हैं?',
  'parent.you_can_download_the_consent_here': 'यदि आपके पास माता-पिता की सहमती फॉर्म पहले से ही नहीं है, तो आप यहां से फॉर्म डाउनलोड कर सकते हैं इसे अपने अभिभावक / अभिभावक द्वारा हस्ताक्षरित करवाएं और उसे अपने अवार्ड लीडर के पास लौटाएं।',
  'footer.copyright': '&copy; कॉपीराइट ड्यूक ऑफ एडिनबर्ग के अंतर्राष्ट्रीय पुरस्कार 2017',
  'registration_participant.required_award_payment': 'पंजीकरण भुगतान आवश्यक',
  'registration_participant.pay_online_here': 'ऑनलाइन भुगतान करें और यहां अपना लेनदेन आईडी प्राप्त करें।',
  'dashboard.activity_log_time': '{hours} घंटे {minutes} मिनट',
  'moduleTitle.award_completed': 'अवार्ड पूरा हो गया!',
  'notifications.award_approval_request_sent_to_leader': 'अवार्ड अनुमोदन अनुरोध आपके अवार्ड लीडर को भेज दिया गया है',
  'notifications.new_participant_event_has_been_completed': 'नई प्रतिभागी घटना पूरी हो चुकी है',
  'notifications.preparation_and_training_approval_sent': 'तैयारी और प्रशिक्षण अनुमोदन भेज दिया गया है',
  'notifications.reparation_and_training_completed': 'तैयारी और प्रशिक्षण पूरा हो चुका है',
  'notifications.your_profile_photo_has_been_edited': 'आपकी प्रोफ़ाइल फ़ोटो संपादित की गई है',
  'notifications.your_profile_has_been_edited': 'आपकी प्रोफ़ाइल संपादित की गई है',
  'notifications.new_level_has_started': 'अगला स्तर शुरू हो गया है',
  'notifications.activity_has_been_edited': 'गतिविधि को संपादित किया गया है',
  'notifications.you_have_been_logged_out': 'लॉग आउट हो रहा ...',
  'notifications.logging_out': 'आपको लॉग आउट कर दिया गया है',
  'label.you_can_send_award_to_leader': 'आप अपने अवार्ड लीडर को अनुमोदन के लिए अपना अवार्ड भेज सकते हैं',
  'label.you_have_completed_all_sections_of_your_award': 'आपने अपने अवार्ड के सभी वर्गों को पूरा कर लिया है अब आप इसे अपने अवार्ड लीडर को अनुमोदन के लिए जमा कर सकते हैं। आप नीचे एक निजी नोट भी जोड़ सकते हैं',
  'label.you_have_now_completed_your_award': 'आपने अब अपना {level} पुरस्कार पूरा कर लिया है क्या आप अगले स्तर को शुरू करना चाहेंगे?',
  'label.congratulation_your_award_has_been_approved': 'आपको बधाई। आपका {level} स्तर पुरस्कार स्वीकृत हो गया है! <br /> यदि आप चाहें, तो आप अगले स्तर पर कार्य शुरू कर सकते हैं।',
  'moduleTitle.settings': 'सेटिंग्स',
  'moduleTitle.edit_activity': 'गतिविधि संपादित करें',
  'moduleTitle.select_your_major_activity': 'अपनी प्रमुख गतिविधि का चयन करें',
  'label.settings': 'सेटिंग्स',
  'label.major_activity_means_that_you_will': 'प्रमुख गतिविधि का अर्थ है कि आपको दूसरों की तुलना में इस गतिविधि पर समय की एक विस्तारित अवधि खर्च करना होगा। गोल्ड लेवल और सिल्वर लेवल के लिए अतिरिक्त समय की आवश्यकता छह महीने है, ब्रोंज लेवल के लिए यह तीन महीने है।',
  'label.notifications': 'सूचनाएं',
  'label.my_award': 'मेरा अवार्ड',
  'label.physical_recreation': 'फिजिकल रिक्रिएशन',
  'label.skill': 'स्किल',
  'label.service': 'सेवा',
  'label.my_parent_will_complete_and_sign_form': 'मेरे माता-पिता / अभिभावक माता-पिता / अभिभावक सहमति पत्र को पूरा और हस्ताक्षर करेंगे',
  'label.please_print_it_tak_it_to_your_parent': 'कृपया इसे प्रिंट करें, इसे हस्ताक्षर करने के लिए अपने माता-पिता / अभिभावक के पास ले जाएं और उसे अपने अवार्ड लीडर को दें',
  'label.change_password': 'पासवर्ड बदलें',
  'label.change_major_activity': 'प्रमुख गतिविधि बदलें',
  'title.change_password': 'पासवर्ड बदलें',
  'label.old_again': 'पुराना पासवर्ड',
  'label.new_password': 'नया पासवर्ड',
  'label.new_password_again': 'फिर से नया पासवर्ड डालें',
  'errors.passwords_dont_match': 'पासवर्ड मेल नहीं खाते',
  'errors.more_than': '{Limit} से अधिक',
  'button.parent_guardian_consent_pdf': 'Parent/guardian consent.pdf',
  'button.send_award_for_approval': 'अनुमोदन के लिए अवार्ड भेजें',
  'button.send_report': 'रिपोर्ट भेजो',
  'button.terms_and_conditions': 'अंतर्राष्ट्रीय नियम एवं शर्तें',
  'button.privacy_policy': 'गोपनीयता नीति',
  'button.save': 'सहेजें',
  'button.start_new_level': 'अगला स्तर प्रारंभ करें',
  'button.change_password': 'पासवर्ड बदलें ',
  'button.edit_activity': 'गतिविधि संपादित करें',
  'moduleTitle.file_upload': 'दस्तावेज अपलोड करें',
  'label.add_file': 'फाइल जोडें',
  'label.description': 'विवरण',
  'label.waiting_for_office_sign_off': 'अवार्ड ऑफिस साइन-ऑफ की प्रतीक्षा में',
  'notifications.file_has_been_uploaded': 'फाइल अपलोड हो गई है',
  'tabs.files': 'फ़ाइलें',
  'button.upload': 'अपलोड',
  'button.upload_file': 'दस्तावेज अपलोड करें',
  'button.add_file': 'फाइल जोडें',
  'button.this_activity_has_no_assessor': 'इस गतिविधि में कोई मूल्यांकनकर्ता नहीं है आपको अनुमोदन के लिए भेजने से पहले मूल्यांकनकर्ता विवरण सेट करना चाहिए।',
  'label.i_want_to_register_my_award': 'मैं अपने अवार्ड यूनिट को इंडिपेंडेंट अवार्ड सेंटर के रूप में पंजीकृत करना चाहता हूं',
  'label.select_sub_operating_authority': 'सब ऑपरेटिंग अथॉरिटी का चयन करें',
  'label.your_must_first_setup_some_activity': 'पहले आपको कुछ गतिविधि को सेटअप करना होगा',
  'label.you_cant_change_your_major_activity': 'आप अपनी प्रमुख गतिविधि को बदल नहीं सकते आपकी प्रमुख गतिविधि पहले से ही पूरी हो चुकी है',
  'label.s_specific': "<b> एस-विशिष्ट: आपका लक्ष्य बहुत व्यापक नहीं होना चाहिए। </b> 'मैं वायलिन में बेहतर होना चाहता हूं', के बजाय आप कह सकते हैं, 'मैं वायलिन बजाने में' एफ स्केल में मास्टर करना चाहता हूं '",
  'label.m_measurable': " <b> एम-मापनीय: आप यह बताने मैं सक्षम होने चाहिए की आपने अपना लक्ष्य कब पूरा किया। </b> अपने लक्ष्यों को सेट करते समय  'मैं समुदाय की मदद करना चाहता हूं', कहने के बजाय आप कह सकते हैं, 'मैं एक सप्ताह में एक बार स्वयंसेवा करके सूप  रसोईघर में जाने वाले लोगों की सहायता करूंगा ' इस तरह से लक्ष्य का परीक्षण किया जा सकता है।",
  'label.a_achievable': "<b> ए-उपलब्धि: आपका लक्ष्य आपके विशिष्ट अवार्ड समय सीमा में कुछ हासिल करना होना चाहिए। </b> यह कहने के बजाय कि 'मैं गरीबी समाप्त करना चाहता हूं', कुछ अधिक व्यावहारिक लक्ष्य निर्धारित करना अच्छा होगा जैसे ' मैं तीसरी दुनिया के गांवों में गरीबी कम करने में मदद करने के लिए धन जुटाना चाहता हूं। '",
  'label.r_realistic': "<b> आर-यथार्थवादी: यह मूल रूप से 'उपलब्धि प्राप्त करने योग्य' के समान है। </b> क्या यह 'यथार्थवादी' है कि आप उस समय सीमा में अपने लक्ष्यों को प्राप्त कर सकते हैं?",
  'label.t_timely': "<b> टी-समय पर: आपका लक्ष्य मैं यह भी शामिल होना चाहिए की कब आप लक्ष्य पूरा करना चाहते हैं। </b> आपका लक्ष्य संभवत: यह हो सकता है, 'मैं तीन महीनों के भीतर वायलिन में एफ पैमाने पर मास्टर करना चाहता हूं।'",
  'label.you_can_upload_here_any_files': 'आप यहां किसी भी फाइल को अपलोड कर सकते हैं, जो आपक अपने अवार्ड लीडर के साथ साझा करना चाहते हैं।',
  'moduleTitle.login_change': 'लॉग इन परिवर्तन',
  'notifications.adventurous_journey_modified': 'साहसिक यात्रा को संशोधित किया गया है',
  'tabs.sections': 'अनुभाग',
  'label.change_email': 'ई - मेल बदलें',
  'title.change_email': 'ई - मेल बदलें',
  'label.new_email': 'नई ईमेल',
  'label.new_email_again': 'नई ईमेल की पुष्टि करें',
  'errors.emails_dont_match': 'ईमेल एक - दूसरे से मेल नहीं खाते',
  'button.change_email': 'ई - मेल बदलें',
  'notifications.email_with_instructions_has_been_sent_to_your_inbox': 'निर्देशों के साथ ईमेल आपके इनबॉक्स में भेजा गया है',
  'global.dofe_name': 'द ड्यूक ऑफ एडिनबर्ग अवार्ड ',
  'global.or': 'या',
  'route.landing_page': 'लैंडिंग पृष्ठ',
  'route.dashboard': 'डैशबोर्ड',
  'moduleTitle.notifications': 'सूचनाएं',
  'moduleTitle.no_notifications': 'कोई सूचनाएं नहीं',
  'moduleTitle.new_notifications': 'नई सूचनाएं',
  'moduleTitle.older_notifications': 'पुरानी सूचनाएं',
  'moduleTitle.user_guide': 'यूजर गाइड्स',
  'label.user_guide': 'यूजर गाइड्स',
  'notifications.your_password_has_been_changed': 'आपका पासवर्ड बदल दिया गया है',
  'label.country': 'देश',
  'label.on_your_smartphone': 'अपने स्मार्टफोन पर',
  'label.on_the_web': 'वेब पर',
  'label.orb_online': 'ORB ऑनलाइन',
  'label.language': 'भाषा',
  'moduleTitle.participant_login': 'प्रतिभागी के रूप में लॉग इन करें',
  'label.for_ios': 'iOS के लिए',
  'label.for_android': 'एंड्रॉयड के लिए',
  'button.login_as_award_staff': 'अवार्ड स्टाफ के रूप में लॉग इन करें',
  'errors.leader_doesnt_exist': 'लीडर मौजूद नहीं है',
  'global.loading': 'लोड हो रहा है',
  'moduleTitle.award_staff_login': 'अवार्ड स्टाफ लॉगिन',
  'formTitle.residential_project_details': 'रेजिडेंशियल प्रोजेक्ट विवरण',
  'label.you_can_also_download_participant': 'आप कभी भी, कहीं भी ऑनलाइन रिकॉर्ड बुक का उपयोग करने के लिए हमारे नए <strong> प्रतिभागी एप </strong> डाउनलोड कर सकते हैं।',
  'label.you_can_also_download_leader': 'आप कभी भी, कहीं भी ऑनलाइन रिकॉर्ड बुक तक पहुंचने के लिए हमारे नए <strong> अवार्ड लीडर अप्प </strong> को डाउनलोड कर सकते हैं।',
  'notifications.this_role_is_not': 'यह भूमिका वर्तमान में समर्थित नहीं है',
  'notifications.residential_project_has_been_updated': 'रेजिडेंशियल प्रोजेक्ट को अद्यतन किया गया है',
  'tabs.participant': 'प्रतिभागी',
  'tabs.award_staff': 'अवार्ड स्टाफ',
  'moduleTitle.edit_residential_project': 'रेजिडेंशियल प्रोजेक्ट को संशोधित करें',
  'button.residential_project': 'रेजिडेंशियल प्रोजेक्ट को संशोधित करें',
  'notifications.your_login_email_has_been_changed': 'आपका लॉगिन ईमेल बदल दिया गया है',
  'meta.dofe_name': 'द ड्यूक ऑफ एडिनबर्ग पुरस्कार',
  'notifications.unknown_role_leader': 'अज्ञात भूमिका - अवार्ड स्टाफ लॉगिन का उपयोग करें',
  'notifications.unknown_role_participant': 'अज्ञात भूमिका - प्रतिभागी लॉगिन का उपयोग करें',
  'label.user_guide_web_participant': 'उपयोगकर्ता वेब गाइड - प्रतिभागी',
  'label.user_guide_app_participant': 'उपयोगकर्ता एप्प गाइड - प्रतिभागी',
  'label.note_for_supervisor': 'पर्यवेक्षक के लिए नोट',
  'label.before_submitting_your_aj': 'अपने अवार्ड लीडर को भेजने से पहले, आपको पहले अपने {role} से अनुमोदन की आवश्यकता है। यदि आप चाहें, तो आप व्यक्तिगत नोट भी जोड़ सकते हैं।',
  'button.back_to_home': 'होम पर वापस जाएँ',
  'moduleTitle.assessor_approval': '{role} अनुमोदन',
  'label.this_aj_has_no_assessor': 'इस साहसिक यात्रा में कोई {role} नहीं है। आपको अनुमोदन के लिए इसे भेजने से पहले जानकारी अपडेट करनी होगी।',
  'route.not_found': 'नहीं मिला',
  'notifications.are_you_sure': 'क्या आप निश्चित हैं?',
  'button.cancel': 'रद्द',
  'label.add_document': 'दस्तावेज़ जोड़ें',
  'errors.there_are_currently_no_details_for_your': 'वर्तमान में आपके {role} के लिए कोई विवरण नहीं है। आकलन के लिए अपनी गतिविधि सबमिट करने से पहले कृपया अपूर्ण विवरण भरें',
  'moduleTitle.missing_data': 'अपूर्ण सूचना',
  'label.to_send_assessment_request': 'यदि आप इलेक्ट्रॉनिक रूप से मूल्यांकन अनुरोध भेजना चाहते हैं, तो कृपया {role} का ईमेल भरें',
  'label.pending_changes': 'परिवर्तन लंबित  ...',
  'label.some_fields_require': 'कुछ फ़ील्ड के लिए आपका ध्यान आवश्यक है',
  'roles.assessor': 'मूल्यांकनकर्ता',
  'roles.supervisor': 'पर्यवेक्षक',
  'pageTitle.register_participant': 'प्रतिभागी पंजीकरण',
  'moduleTitle.revise_message': 'संदेश संशोधित करें',
  'moduleTitle.payment_for_level': '{AwardLevel} के लिए भुगतान',
  'moduleTitle.payment': 'प्रतिभागी पंजीकरण शुल्क भुगतान',
  'moduleTitle.we_have_sent_you_payment_link': 'हमने आपको पेमेंट गेटवे के लिंक के साथ एक ईमेल भेजा है',
  'label.required_award_payment': 'अवार्ड पेमेंट आवश्यक',
  'label.payment_fees': 'भुगतान शुल्क',
  'label.payment_method': 'भुगतान का तरीका',
  'label.you_will_type_trans_id': 'आपको अपने लेनदेन आईडी में टाइप करने के लिए कहा जाएगा',
  'label.any_level_previously': 'कोई स्तर जो पहले पूरा किया हो',
  'label.registering_for_level': 'स्तर के लिए पंजीकरण',
  'notification.payment_link_expired': 'भुगतान लिंक की समय सीमा समाप्त हो गई है',
  'button.pay': 'भुगतान करें',
  'label.registration_updated': 'पंजीकरण अपडेट कर दिया गया है, अब आप इस पेज को बंद कर सकते हैं।',
  'label.award_leader_receive_payment': 'अवार्ड लीडर को भुगतान के बारे में जानकारी प्राप्त होगी।',
  'errors.end_date_after': 'समाप्ति तिथि प्रारंभ तिथि के बाद होनी चाहिए',
  'button.back': 'पीछे',
  'button.edit_info': 'जानकारी संपादित करें',
  'moduleTitle.level_detail': 'स्तर का विवरण',
  'label.payment_methods': 'भुगतान की विधि',
  'label.address': 'पता',
  'note.review_filled_participant': 'प्रतिभागी द्वारा भरी गई जानकारी की समीक्षा करें यदि आप कुछ गलत पाते हैं, तो आप उन्हें संपादित कर सकते हैं।',
  'moduleTitle.payment_successful': 'प्रतिभागी पंजीकरण भुगतान सफल था',
  'button.proceed_to_login': 'लॉगिन करने के लिए आगे बढ़ें',
  'label.add_additional_activity': 'अतिरिक्त गतिविधि जोड़ें',
  'moduleTitle.welcome_to_orb': 'ऑनलाइन रिकॉर्ड बुक में आपका स्वागत है',
  'empty_dashboard.not_approved': 'यह टूल आपको अपने अवार्ड के दौरान अपनी प्रगति रिकॉर्ड करने में मदद करेगा। लेकिन आपकी प्रोफ़ाइल आपके अवार्ड लीडर द्वारा अभी तक अनुमोदित नहीं है। अपनी पहली गतिविधि बनाना शुरू करने से पहले, आपको अनुमोदन के लिए इंतजार करना होगा।',
  'empty_dashboard.approved_1': 'यह टूल आपको अपने अवार्ड के दौरान अपनी प्रगति रिकॉर्ड करने में मदद करेगा।',
  'empty_dashboard.approved_2': 'पहले आपको अपना एक गतिविधि सेट करना होगा, शुरू करने के लिए, बाईं ओर क्लिक करें यदि आपको गतिविधि सेटअप के साथ कुछ मदद की आवश्यकता है, सहायता के लिए अपने अवार्ड लीडर से पूछें।',
  'label.discuss_activity_leader': 'यदि आप एक से अधिक गतिविधि का चयन कर रहे हैं, तो कृपया अपने अवार्ड लीडर के साथ पहले चर्चा करें।',
  'label.cannot_add_activity': 'आप इस श्रेणी के लिए अधिकतम 3 गतिविधियों को जोड़ सकते हैं। कृपया अपने अवार्ड नेता के साथ इस पर चर्चा करें',
  'button.ok': 'ठीक',
  'label.payment_was_canceled': 'उपयोगकर्ता द्वारा भुगतान रद्द कर दिया गया था',
  'label.problem_with_payment': 'आपका भुगतान संसाधित करने में एक समस्या थी कृपया अपने नेशनल अवार्ड ऑपरेटर (NAO) से संपर्क करें',
  'pageTitle.register_leader': 'लीडर रजिस्टर करें',
  'pageTitle.registration_complete': 'पंजीकरण पूर्ण',
  'label.payment_link_expired_or_paid': 'आपने पहले ही भुगतान पंजीकरण शुल्क के लिए भुगतान कर दिया  है या भुगतान लिंक की समय सीमा समाप्त हो गई है।',
  'label.contact_nao_assistance': 'यदि आपको सहायता की आवश्यकता है तो अपने NAO से संपर्क करें',
  'label.send_required_amount_to_your_award_leader': 'अपने यूनिट में अपने अवार्ड लीडर या अवार्ड समन्वयक को आवश्यक राशि भेजें।',
  'label.fee_can_be_paid': 'शुल्क का भुगतान वीसा, मास्टर कार्ड या क्रेडिट डेबिट कार्डों से ऑनलाइन किया जा सकता है।',
  'notifications.login_failed_right_tab': 'लॉग इन असफल, सुनिश्चित करें कि आप सही टैब (प्रतिभागी / अवार्ड स्टाफ) में हैं।',
  'label.i_have_read_privacy_policy': 'मैंने गोपनीयता नीति पढ़ ली है और इसके साथ सहमत हूं',
  'errors.invalid_date_format': 'अमान्य तिथि प्रारूप',
  'label.no_privacy_policy': 'आप फिनिश बटन पर क्लिक करके आगे बढ़ सकते हैं',
  'label.status': 'स्थिति',
  'moduleTitle.attached_with_observation': 'अवलोकन के साथ संलग्न',
  'moduleTitle.revise_message_rp': 'आपके रेजिडेंशियल प्रोजेक्ट  को आपके अवार्ड लीडर ने संशोधित किया है',
  'file.activity_section_summary': '{section} -अनुभाग-सारांश',
  'label.download_section_summary': 'अनुभाग सारांश डाउनलोड करें',
  'label.award_summary': 'पुरस्कार सारांश',
  'btn.download_summary_for_assessor': 'निर्धारक के लिए सारांश डाउनलोड करें',
  'label.first_activity_started': 'पहली गतिविधि शुरू हुई',
  'label.hours_completed_required': 'पूरा / आवश्यक घंटे',
  'label.weeks_completed_required': 'पूर्ण / आवश्यक सप्ताह',
  back_to_home: 'मुखपृष्ठ पर वापस जाएं',
  'label.activity_rejected_click': 'आपकी गतिविधि अवार्ड लीडर द्वारा अस्वीकार कर दिया गया है ␣ के लिए क्लिक करें',
  'button.more_information': 'अधिक जानकारी',
  'label.attached_file': 'संलग्न फाइल',
  'moduleTitle.journey_details': 'यात्रा विवरण',
  'tabs.activity': 'गतिविधि',
  'label.confirm_email': 'ईमेल की पुष्टि करें',
  'label.aj_rejected_click': 'आपकी यात्रा अवार्ड लीडर द्वारा अस्वीकार कर दिया गया है ␣ के लिए क्लिक करें ',
  'label.verifying_payment': 'भुगतान का सत्यापन',
  'button.finish_and_pay': 'समाप्त करें और भुगतान करें',
  'label.payment_not_successful_text': 'जैसा कि आपने अवार्ड का भुगतान सफलतापूर्वक पूरा नहीं किया है, इसलिए अब भुगतान करना आवश्यक है',
  'label.payment_not_completed': 'भुगतान पूरा नहीं हुआ',
  'button.pay_now': 'अब भुगतान करें',
  'label.registration_pending_parental_consent': 'आपका पंजीकरण अभिभावक / अभिभावक सहमति लंबित है',
  'button.edit_observation': 'अवलोकन को संपादित करें',
  'moduleTitle.qualifying': 'योग्यता',
  'moduleTitle.practice': 'अभ्यास',
  'label.first_log_entry': 'प्रथम लॉग प्रविष्टि',
  'label.first_log_entry_date': 'प्रथम लॉग प्रविष्टि तिथि',
  'label.last_log_entry': 'अंतिम लॉग प्रविष्टि',
  'label.last_log_entry_date': 'अंतिम लॉग प्रविष्टि तिथि',
  'label.you_can_send_journey_report_for_approval': 'आप अपनी {journey} यात्रा की रिपोर्ट स्वीकृति के लिए भेज सकते हैं।',
  'button.edit_and_resend_report': 'रिपोर्ट संपादित और पुनः भेजें',
  'label.your_journey_is_complete': 'आपका {journey Type} यात्रा पूरी हो गई है।',
  'button.add_additional_journey': 'अतिरिक्त यात्रा जोड़ें',
  'moduleTitle.edit_journey': 'यात्रा संपादित करें',
  'notifications.assessment_sent': 'आकलन भेजा गया है',
  'notifications.file_is_too_big': 'फ़ाइल अपलोड नहीं की जा सकती यह शायद बहुत बड़ी है',
  'notifications.authorization_code_has_expired': 'प्राधिकरण कोड की समय सीमा समाप्त हो गई है',
  'route.confirm_email': 'ईमेल की पुष्टि करें',
  'label.assessor_needs_account': 'ऑनलाइन रिकॉर्ड बुक (ORB) पर काम करने के लिए आपको निजी ORB खाते की आवश्यकता है। <br/> कृपया अपना विवरण यहां बनाएं',
  'label.company_name': 'कंपनी का नाम',
  'label.secondary_email_again': 'वैकल्पिक ईमेल की पुष्टि करें',
  'label.how_many_years': 'कितने साल / महीने?',
  'label.no_company_leave_empty': 'अगर आप किसी भी कंपनी के लिए काम नहीं करते हैं, तो खाली छोड़ दें',
  'label.secondary_phone_number': 'वैकल्पिक फोन नंबर',
  'label.secondary_phone_type': 'वैकल्पिक फोन नंबर',
  'label.wwc_application_number': 'बाल संरक्षण संख्या',
  'label.wwc_expiration_date': 'बाल संरक्षण समाप्ति तिथि',
  'label.you_are_now_registering_as_assessor': 'अब आप एक मूल्यांकनकर्ता बनने के लिए पंजीकरण कर रहे हैं',
  'label.you_have_finished_aj_now_send_to_approval': 'आपका रेजिडेंशियल प्रोजेक्ट समाप्त हो गया है अब आप इसे अपने मूल्यांकनकर्ता के लिए अनुमोदन के लिए जमा कर सकते हैं। आप नीचे एक निजी नोट भी जोड़ सकते हैं',
  'label.your_experience': 'आपका अनुभव',
  'label.your_qualification': 'आपकी योग्यता',
  'notifications.waiting_for_assessor_approval': 'मूल्यांकनकर्ता अनुमोदन की प्रतीक्षा कर रहा है',
  'button.resend_assessment_request': 'आकलन अनुरोध फिर से भेजें',
  'errors.emails_must_be_different': 'वैकल्पिक ईमेल प्राथमिक से अलग होना चाहिए I',
  'moduleTitle.company_details': 'संस्थान के विवरण',
  'notifications.already_resent_assessment_request': 'आप पहले से ही आकलन अनुरोध दोबारा भेज चुके हैं',
  'route.assessor_dashboard': 'मूल्यांकनकर्ता डैशबोर्ड',
  'pageTitle.register_assessor': 'मूल्यांकनकर्ता पंजीकरण',
  'wizard.assessor_details': 'मूल्यांकनकर्ता का विवरण',
  'wizard.assessor_experience': 'मूल्यांकनकर्ता का अनुभव',
  'wizard.personal_details': 'व्यक्तिगत सुचना',
  'button.sign_off': 'साइन ऑफ़',
  'button.sign_off_dashed': 'साइन-ऑफ़',
  'moduleTitle.sign_off': 'साइन ऑफ़',
  'label.certify_participant_met_reqs': 'मैं इस गतिविधि के मूल्यांकनकर्ता के रूप में प्रमाणित करता हूं कि प्रतिभागी इस गतिविधि की सभी आवश्यकताओं को पूरा करता है।',
  'label.assessor_report': 'मूल्यांकनकर्ता की रिपोर्ट',
  'label.content_update': 'कृपया प्रतीक्षा करें। सामग्री अपडेट कर रहा है ...',
  'label.comment_on_participant_improvement': 'कृपया प्रतिभागी की सुधार / प्रदर्शन प्रतिबद्धता पर टिप्पणी करें',
  'note.edit_participant_review': 'इस जानकारी में से किसी को सुधारने के लिए संपादन जानकारी बटन पर क्लिक करें।',
  'errors.min_age': 'न्यूनतम उम्र {age} है',
  'notifications.assessor_link_expired': 'मूल्यांकनकर्ता के पंजीकरण लिंक की समय सीमा समाप्त हो गई है।',
  'label.secondary_email': 'वैकल्पिक ईमेल',
  'moduleTitle.review_participant_info': 'प्रतिभागी की जानकारी की समीक्षा करें',
  'label.loading_payment_gateway': 'भुगतान गेटवे लोड हो रहा है',
  'label.consent_given_login_as_child': 'सहमति पहले ही दी गई थी। कृपया अपने बच्चे के रूप में लॉगिन करें',
  'notifications.only_one_qualification_journey_per_award': 'अवार्ड के भीतर केवल एक योग्यतापूर्ण साहसिक यात्रा को  स्थापित किया जा सकता है',
  'label.registration_fees_participant': 'पंजीकरण शुल्क भुगतान - {name} (# {id})',
  'moduleTitle.leader_details': 'लीडर का विवरण',
  'label.leader_name': 'लीडर का नाम',
  'label.leader_phone': 'लीडर का फ़ोन नंबर',
  'label.leader_email': 'लीडर का ईमेल',
  'moduleTitle.au_details': 'अवार्ड यूनिट का विवरण',
  'label.au_name': 'अवार्ड यूनिट का नाम',
  'label.assessor_guidelines': 'दिशा-निर्देश',
  'label.assessor_cond_req': 'प्रमुख स्थितियां और आवश्यकताएँ',
  'label.assessor_ref_handbook': 'अवार्ड पुस्तिका को संदर्भ',
  'label.assessor_ref_online_modules': 'ऑनलाइन सीखने के मॉड्यूल के संदर्भ',
  'label.participant_has_no_aj_report': 'प्रतिभागी ने अभी तक एक रिपोर्ट जमा नहीं की है',
  'moduleTitle.participant_details': 'प्रतिभागी विवरण',
  'label.participants_has_no_logs': 'प्रतिभागी के पास अभी तक कोई लॉग नहीं है',
  'label.location_type': 'स्थान प्रकार',
  'label.activity_ready_for_signoff': 'यह गतिविधि साइन ऑफ के लिए तैयार है',
  'label.activities': 'गतिविधियाँ',
  'label.choose_how_you_want_to_login': 'चुनें कि आप कैसे प्रवेश करना चाहते हैं:',
  'roles.leader': 'लीडर',
  'roles.award_verifier': 'अवार्ड सत्यापनकर्ता',
  'roles.coordinator': 'समन्वयक',
  'roles.aj_assessor': 'साहसिक यात्रा मूल्यांकनकर्ता',
  'roles.aj_supervisor': 'साहसिक यात्रा पर्यवेक्षक',
  'roles.instructor': 'प्रशिक्षक',
  'roles.nao_staff': 'कोई कर्मचारी नहीं',
  'roles.super_user': 'सुपर उपयोगकर्ता',
  'roles.user': 'उपयोगकर्ता',
  'roles.viewer': 'दर्शक',
  'roles.authorizing_contact': 'संपर्क प्राधिकृत करना',
  'roles.if_staff_superuser': 'आई ऍफ़  स्टाफ सुपर उपयोगकर्ता',
  'roles.if_staff_statistical_user': 'आई ऍफ़  सांख्यकी उपयोगकर्ता ',
  'roles.if_staff_viewer': 'आई ऍफ़  स्टाफ व्यूअर',
  'roles.aj_instructor': 'ए जे प्रशिक्षक',
  'label.if_you_have_questions_au': 'यदि आपके पंजीकरण के बारे में आपके कोई प्रश्न हैं, तो कृपया अपने अवार्ड यूनिट से संपर्क करें।',
  'label.we_will_send_you_an_email_leader': 'जब आपका ORB खाता पंजीकरण स्वीकृत हो जाता है तो हम आपको एक ईमेल भेजेंगे।',
  'moduleTitle.rejecting_assessor_invitation': 'मूल्यांकनकर्ता बनने के लिए आमंत्रण को अस्वीकार करना',
  'notifications.assessor_invitation_rejected': 'मूल्यांकनकर्ता बनने के लिए आमंत्रण को अस्वीकार कर दिया गया है',
  'moduleTitle.participants_list_is_empty': 'प्रतिभागियों की सूची खाली है',
  'label.note_from_participant': 'प्रतिभागी से नोट',
  'label.you_can_send_aj_to_leader': 'अब आप अनुमोदन के लिए अपने अवार्ड लीडर को अपने साहसिक यात्रा भेज सकते हैं।',
  'button.save_report': 'रिपोर्ट सहेजें',
  'label.this_activity_has_no_assessor': 'इस गतिविधि में कोई मूल्यांकनकर्ता नहीं है आपको अनुमोदन के लिए भेजने से पहले मूल्यांकनकर्ता विवरण सेट करना चाहिए।',
  'label.activity_rejected_click_by_assessor': 'आपकी गतिविधि को मूल्यांकनकर्ता ने अस्वीकार कर दिया है  आगे क्लिक करें',
  'button.reject': 'अस्वीकार',
  'button.reject_invitation': 'आमंत्रण अस्वीकार करें',
  'label.reason': 'कारण',
  'label.accept_invitation_and_continue': 'आमंत्रण स्वीकार करें और जारी रखें',
  'pageTitle.registration_reject': 'आमंत्रण स्वीकार करें और जारी रखें',
  'errors.you_must_be_older_than_register_for_leader': 'अवार्ड लीडर के रूप में पंजीकरण करने के लिए आपको {years} वर्ष और {महीनों} महीनों से अधिक उम्र का होना चाहिए।',
  'label.your_report_approve_now_send_to_leader_without_note': 'आपकी रिपोर्ट मंजूर कर दी गई है! अब आप इसे अपने अवार्ड लीडर को अनुमोदन के लिए जमा कर सकते हैं।',
  'button.stop_assessing_this_activity': 'इस गतिविधि का आंकलन बंद करें',
  'button.confirm': 'पुष्टि',
  'moduleTitle.are_you_sure': 'क्या आपको यकीन है?',
  'label.content_restore': 'सामग्री पुनर्स्थापना',
  'button.stop_editing': 'संपादन रोकें',
  'notifications.activity_has_been_rejected': 'गतिविधि को अस्वीकार कर दिया गया है',
  'notifications.aj_has_been_rejected': 'साहसिक यात्रा को अस्वीकार कर दिया गया है',
  'notifications.rp_has_been_rejected': 'रेजिडेंशियल प्रोजेक्ट को अस्वीकार कर दिया गया है',
  'moduleTitle.additional_files': 'अतिरिक्त फ़ाइलें',
  'moduleTitle.no_additional_files': 'अतिरिक्त फ़ाइलें',
  'moduleTitle.stop_assessing_section': 'अनुभाग का मूल्यांकन करना बंद करें',
  'label.show_security_and_refund_policy': 'सुरक्षा और धनवापसी नीति दिखाएं',
  'moduleTitle.security_and_refund_policy': 'सुरक्षा और धन वापसी नीति',
  'label.fees_payment': 'फीस का भुगतान',
  'label.redund_policy': 'धन वापसी नीति',
  'label.security_policy': 'सुरक्षा नीति',
  'label.leave_blank': 'खाली छोड़ दें',
  'label.frequently_asked_questions': 'अक्सर पूछे जाने वाले प्रश्न',
  'label.language_selection_is_disabled_for_iac': 'आईएसी के लिए भाषा चयन अक्षम है',
  'errors.min_nights_required': 'न्यूनतम रातों  (nights) की आवश्यकता है',
  'label.completion_date': 'पूरा करने की तिथि',
  'label.you_are_offline': 'आप ऑफलाइन हैं। अब किए गए परिवर्तन सहेजे नहीं जा सकते।',
  'errors.start_date_after_award_start': 'वर्तमान अवार्ड शुरू होने से पहले आरंभ तिथि नहीं हो सकती',
  'label.participants': 'प्रतिभागी',
  'label.marketing_from_iaf': 'इंटरनेशनल फाउंडेशन से विपणन सामग्री प्राप्त करने के लिए ऑप्ट इन करें',
  'label.marketing_from_oa': 'आपरेटिंग प्राधिकरण से विपणन सामग्री प्राप्त करने में ऑप्ट इन करें',
  'label.marketing_from_nao': 'NAO से विपणन सामग्री प्राप्त करने के लिए ऑप्ट इन करें',
  'label.select_iac': 'स्वतंत्र अवार्ड केंद्र का चयन करें',
  'label.you_will_be_redirected_to_the_paypal_payment': 'अपने वीज़ा, मास्टरकार्ड क्रेडिट कार्ड, वीज़ा डेबिट कार्ड या पेपैल खाते का उपयोग करके ऑनलाइन भुगतान करने के लिए ऊपर दिए गए पे बटन पर क्लिक करें।',
  'notifications.report_has_been_sent': 'रिपोर्ट भेज दी गई है',
  'label.processing_paypal_payment': 'पेपैल भुगतान प्रसंस्करण',
  'label.loading_paypal_gateway': 'पेपैल गेटवे लोड हो रहा है',
  'label.payment_failed': 'भुगतान असफल हुआ',
  'label.payment_has_been_cancelled': 'भुगतान रद्द कर दिया गया है या विफल रहा है',
  'roles.naa_oa_staff': 'NAO स्टाफ',
  'label.download_report_and_upload_signed_version': 'रिपोर्ट डाउनलोड करें और हस्ताक्षरित संस्करण अपलोड करें',
  'button.download_summary_for_assessor': 'मूल्यांकनकर्ता के लिए सारांश डाउनलोड करें',
  'label.pay_online_mastercard': 'ऑनलाइन भुगतान करें',
  'label.pay_online_paypal': 'ऑनलाइन भुगतान करें',
  'notifications.authorization_code_is_missing': 'प्रमाणीकरण कोड नहीं है',
  'errors.unknown_payment_error': 'भुगतान के दौरान अज्ञात त्रुटि आई',
  'errors.already_in_use_by_auth_contact': 'यह ईमेल पहले से ही उपयोग में है',
  'roles.if_staff_stat_user': 'आई ऍफ़ सांख्यिकीय उपयोगकर्ता',
  'moduleTitle.you_have_been_logged_out_due_to_inactivity': 'निष्क्रियता के कारण आप लॉग आउट हो गए हैं',
  'announcement.survey_description.do_think_people_are_lazy': 'क्या आपको लगता है कि युवा लोग आलसी हैं या हकदार हैं? चाहे आप एक युवा व्यक्ति हों या वयस्क हों, कृपया हमारे वैश्विक सर्वेक्षणों में से एक भरें और हमें बताएं कि आप आज के युवा लोगों के बारे में क्या सोचते हैं।',
  'announcement.survey_title.join_our_global_survey': 'हमारे वैश्विक सर्वेक्षण में शामिल हों',
  'announcement.survey_button.if_below_25': 'यदि आप 16-25 हैं',
  'announcement.survey_button.if_over_25': 'यदि आप 25 से अधिक हैं',
  'moduleTitle.privacy_and_cookie_policy': 'गोपनीयता और कुकीज़ नीति',
  'label.we_have_made_some_important_changes': 'हमने अपनी गोपनीयता और कुकीज़ नीति में कुछ महत्वपूर्ण बदलाव किए हैं और हम चाहते हैं कि आप यह जान लें कि इसका मतलब आपके और आपके डेटा के लिए क्या है।',
  'button.i_agree': 'मैं सहमत हूँ',
  'button.see_more_details': 'अधिक जानकारी देखें',
  'label.the_cookie_settings_on_this': 'आपको सबसे अच्छा ब्राउज़िंग अनुभव देने के लिए इस वेबसाइट पर कुकी सेटिंग्स को &quot;कुकीज़ की अनुमति दें&quot; पर सेट किया गया है।  यदि आप अपनी कुकी सेटिंग्स को बदले बिना इस वेबसाइट का उपयोग करना जारी रखते हैं या आप &quot;स्वीकार करें&quot; पर क्लिक करें। नीचे आप इस से सहमत हैं।',
  'label.after_your_rp_describe': '',
  'label.you_are_going_to_be_logged_out': ''
}
